import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayers } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

const ErrorTopicLayerNotification = ({
  layerId,
  title,
}: {
  layerId: string;
  title: string;
}) => {
  const { t } = useTranslation('agisviewer');
  const addNotification = useAppState((state) => state.addNotification);
  const removeNotification = useAppState((state) => state.removeNotification);
  useEffect(() => {
    const notificationId = `error-${layerId}`;

    addNotification({
      id: notificationId,
      title,
      message: t('notification_topic_loading_error', { topicLayerName: title }),
      type: 'negative',
    });
    return () => removeNotification(notificationId);
  }, []);

  return null;
};

const ErrorTopicLayerNotifications = () => {
  const errorLayers = useAppState((state) => state.errorLayers);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);

  const { data: layersLookup, isLoading } = useLayers();

  if (isLoading) return null;

  return errorLayers
    .filter((layer) => selectedTopicLayers.includes(layer))
    .map((layer) => (
      <ErrorTopicLayerNotification
        key={layer}
        layerId={layer}
        title={layersLookup[layer]?.title ?? layer}
      />
    ));
};

export default ErrorTopicLayerNotifications;
